import React from 'react';
import { useNavigate } from 'react-router';
import TopicsNavigation from '../../components/TopicsNavigation';
import VideoPlayerFull from '../../components/VideoPlayerFull';
import Page from '../Page';
import { useState } from 'react';
import AfterVideo from '../../components/AfterVideo';
import PageIntro from '../PageIntro';

export default function QualityAssurance() {

  const [showNavigation, setShowNavigation] = useState(false);
  const [hideIntro, setHideIntro] = useState(false);

  return (
    <Page
      outroInstant={true}
      content={
        <>
          <div className={`video-intro ${hideIntro ? 'hide-intro' : ''}`}>
            <PageIntro content={
              <>
                <div className="topic-intro-title">
                  Quality<br></br>Assurance
                </div>
              </>
            } />
          </div>
          <VideoPlayerFull
            url="https://vimeo.com/872586859"
            urlMobile="https://vimeo.com/877892990"
            onEnd={() => setShowNavigation(true)}
            onStart={() => {
              setTimeout(function() {
                setHideIntro(true);
              }, 100);
            }}
          />
          <AfterVideo
            text={
              <>
                Ensure top-notch<br></br>product and service quality
              </>
            }
            isShowing={showNavigation}
          />
          <TopicsNavigation isShown={showNavigation} />
        </>
      }
    />
  );
}
